import { createContext, useContext } from 'react'

export type InvoiceCustomerScope = 'standard' | 'factoring'

const InvoiceWorkspaceContext = createContext<InvoiceCustomerScope>('standard')

export const InvoiceWorkspaceProvider = InvoiceWorkspaceContext.Provider

export const useInvoiceWorkspaceScope = () => useContext(InvoiceWorkspaceContext)
